import { IPageDataReducer } from '../reducers/pageData';

export const shutdownRedirect = (pageData: IPageDataReducer, location: Location) => {
    let slugs: string[];
    switch (pageData.appConfig.countryCode) {
        case 'br':
            slugs = [
                '/contatos-reservas-remarcacoes',
                '/aviso-legal',
                '/termos-e-condicoes',
                '/politica-de-privacidade',
                '/clearcache',
            ];
            break;
        default:
            return;
    }

    const slugsRegEx = new RegExp(slugs.join('|'));

    if (!slugsRegEx.test(location.pathname) && location.pathname.length > 1) {
        window.location.href = pageData.config.contentEndpoint;
        return;
    }

    return;
};
